import { getApp } from "./firebaseConfig";
import { getStorage } from 'firebase/storage';

const storage = getStorage(getApp());

export default storage;